import * as React from 'react';
import { css } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { COLORS } from '../../globalStyle/colors';
import { FLEX_ROW } from '../../layout/flexBox';
import Msg from '../../localization/Msg';
import { Str } from '../../localization/translationKeys';
import Spacer from '../../layout/Spacer';
import { Routes } from '../../navigation/routes';
import { Link } from 'react-router-dom';


const styles = {
  link:    [
    FLEX_ROW,
    css`
      background-color: ${COLORS.WHITE};
      border-radius: 10px;
      padding: 25px;

      color: ${COLORS.MEDIUM_GREY};
      align-items: center;
      text-decoration: none;
      
      &:hover { 
        color: ${COLORS.BLUE};
      }
    `,
  ],
  addIcon: css`
    font-size: 20px;
  `,
  msg:     css`
    font-size: 12px;
  `,

};


type Props = {
  routes: Routes;
  className?: string;
};


/**
 * AddDevItemCard: a component that renders a pretty link to the new plan item modal.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const AddDevItemCard: React.FC<Props> = props => (
  <Link to={props.routes.AddPlanItem} css={styles.link} className={props.className}>
    <FontAwesomeIcon icon={faPlus} css={styles.addIcon} />
    <Spacer sizePx={20} />
    <Msg str={Str.AddDevItem} css={styles.msg} />
  </Link>
);

export default AddDevItemCard;
